// Panel tarjimasi (2/3): ruscha. Kalit — o'zbekcha matn.
const lugat = {
  // --- Ovozli yig'ilish ---
  "Ma'lumot olinmadi": "Данные не получены",
  "Ulanib bo'lmadi: {message}": "Не удалось подключиться: {message}",
  "Yig'ilish nomini kiriting": "Введите название собрания",
  "Yig'ilish boshlandi. Bildirishnoma yuborildi: ": "Собрание началось. Уведомление отправлено: ",
  "{xabar_yuborildi} / {xabar_kutilgan} xodimga.": "{xabar_yuborildi} из {xabar_kutilgan} сотрудникам.",
  "Yig'ilish boshlanmadi": "Собрание не началось",
  "Yig'ilish yakunlansinmi? Barcha ishtirokchilar uziladi.": "Завершить собрание? Все участники будут отключены.",
  "Yig'ilish yakunlandi.": "Собрание завершено.",
  "Yakunlanmadi": "Не завершено",
  "So'z berilmadi": "Слово не предоставлено",
  "Siz gapirasiz — tumanlar eshitadi. Biror tumandan javob olish uchun ro'yxatdan \"So'z berish\" tugmasini bosing. Bir vaqtda faqat bitta tuman gapira oladi.": "Вы говорите — районы слушают. Чтобы получить ответ от района, нажмите «Дать слово» в списке. Одновременно может говорить только один район.",
  "Yangi yig'ilish": "Новое собрание",
  "Yig'ilish nomi * (masalan: Haftalik hisobot)": "Название собрания * (например: Еженедельный отчёт)",
  "Boshlanmoqda...": "Запуск...",
  "🎙️ Boshlash": "🎙️ Начать",
  "Boshlash bilan barcha tumanga biriktirilgan xodimlarga telefoniga bildirishnoma yuboriladi.": "При запуске всем сотрудникам, привязанным к районам, на телефон придёт уведомление.",
  "JONLI": "В ЭФИРЕ",
  "Boshlangan: {toLocaleString}": "Начало: {toLocaleString}",
  "{qolKotarganlar} ta savol": "вопросов: {qolKotarganlar}",
  "Ulanmoqda...": "Подключение...",
  "🎧 Ulanish": "🎧 Подключиться",
  "🎙️ Mikrofon ochiq": "🎙️ Микрофон включён",
  "🔇 Jim": "🔇 Без звука",
  "Yakunlash": "Завершить",
  "Ishtirokchilar ({soni})": "Участники ({soni})",
  "Hali hech kim qo'shilmadi.": "Пока никто не подключился.",
  "gapirmoqda...": "говорит...",
  "siz": "вы",
  "So'zni qaytarish": "Забрать слово",
  "So'z berish": "Дать слово",
  "Yig'ilish davom etmoqda, lekin siz ulanmagansiz. Gapirish va so'z berish uchun \"Ulanish\" tugmasini bosing.": "Собрание идёт, но вы не подключены. Чтобы говорить и давать слово, нажмите «Подключиться».",
  "O'tgan yig'ilishlar": "Прошедшие собрания",
  "Boshlovchi": "Ведущий",
  "Sana": "Дата",
  "Davomiylik": "Длительность",
  "Ishtirokchi": "Участники",
  "jonli": "в эфире",
  "{round} daq": "{round} мин",
  "Hali yig'ilish o'tkazilmagan.": "Собраний пока не было.",

  // --- Anonim murojaatlar ---
  "Taklif": "Предложение",
  "Shikoyat": "Жалоба",
  "Savol": "Вопрос",
  "Murojaatlarni yuklab bo'lmadi": "Не удалось загрузить обращения",
  "Amal bajarilmadi": "Действие не выполнено",
  "Bu murojaat o'chirilsinmi?\n\nQaytarib bo'lmaydi.": "Удалить это обращение?\n\nОтменить нельзя.",
  "O'chirib bo'lmadi": "Не удалось удалить",
  "{unreadCount} yangi": "новых: {unreadCount}",
  "Murojaatlar to'liq anonim — kim yozgani saqlanmaydi va aniqlab bo'lmaydi.": "Обращения полностью анонимны — автор не сохраняется и не может быть установлен.",
  "Hammasi ({soni})": "Все ({soni})",
  "O'qilmagan ({unreadCount})": "Непрочитанные ({unreadCount})",
  "Hali murojaat kelmagan.": "Обращений пока нет.",
  "Bu bo'limda murojaat yo'q.": "В этом разделе обращений нет.",
  "yangi": "новое",
  "O'qilmagan deb belgilash": "Отметить как непрочитанное",
  "O'qildi": "Прочитано",

  // --- Menyu ---
  "Avval \"Tumanlar\" bo'limida tuman qo'shing": "Сначала добавьте район в разделе «Районы»",
  "Manguberdi": "Manguberdi",
  "Probatsiya bo'limi": "Отдел пробации",
  "Mahkumlar reyestri": "Реестр осуждённых",
  "Masofaviy nazorat": "Дистанционный контроль",
  "Sayyor sud": "Выездной суд",
  "Chiqish": "Выход",
  "Admin panel": "Панель администратора",
  "Dashboard": "Главная",
  "SOS signallari": "SOS-сигналы",
  "Kunlik vazifalar": "Ежедневные задачи",
  "Taqdimnoma shablonlari": "Шаблоны представлений",
  "Yuklab olishlar": "Скачивания",
  "Eslatmalar": "Напоминания",
  "Qonun hujjatlari": "Законодательство",
  "GPS davomat": "GPS-посещаемость",
  "Ish zonalari": "Рабочие зоны",
  "Anonim murojaatlar": "Анонимные обращения",
  "Ovozli yig'ilish": "Голосовое собрание",
  "Tumanlar": "Районы",
  "Probatsiya nazorati": "Контроль пробации",

  // --- Masofaviy nazorat ---
  "Uydan chiqdi": "Покинул дом",
  "GPS o'chirildi": "GPS выключен",
  "Joylashuv ruxsati olib tashlandi": "Разрешение на геолокацию отозвано",
  "Soxta GPS aniqlandi": "Обнаружен поддельный GPS",
  "Aloqa yo'q": "Нет связи",
  "Batareya kam": "Низкий заряд",
  "Qurilma o'zgardi": "Устройство сменилось",
  "Qurilma vaqti o'zgartirilgan": "Время устройства изменено",
  "Uyda edi": "Был дома",
  "Uyda yo'q edi": "Не был дома",
  "Eshik ochilmadi": "Дверь не открыли",
  "Javob bermadi": "Не ответил",
  "Texnik nosozlik": "Техническая неисправность",
  "hech qachon": "никогда",
  "hozir": "сейчас",
  "{n} daq oldin": "{n} мин назад",
  "{n} soat oldin": "{n} ч назад",
  "{n} kun oldin": "{n} дн. назад",
  "Ilova yo'q": "Нет приложения",
  "Aloqa yo'q ({n} daq)": "Нет связи ({n} мин)",
  "Uyda": "Дома",
  "Ishda ({n} m)": "На работе ({n} м)",
  "Uydan tashqarida ({n} m)": "Вне дома ({n} м)",
  "Ma'lumot yo'q": "Нет данных",
  "To'liq taqiq": "Полный запрет",
  "Qisman cheklov": "Частичное ограничение",
  "Saqlashda xato": "Ошибка сохранения",
  "Nazorat sozlamalari — {familiya} {ism}": "Настройки контроля — {familiya} {ism}",
  "Jazo rejimi (JK 48-1-modda)": "Режим наказания (ст. 48-1 УК)",
  "Uy-joyni bu yoki bu bahona bilan tark etish butunlay taqiqlanadi. Tekshiruv normasi: oyiga kamida 3 marta (403-buyruq, 84-band)": "Покидать жилище под любым предлогом полностью запрещено. Норма проверок: не менее 3 раз в месяц (приказ № 403, п. 84)",
  "Ish/o'qish vaqti va yo'l vaqtidan tashqari chiqish taqiqlanadi. Tekshiruv normasi: oyiga kamida 1 marta (403-buyruq, 85-band)": "Выход вне времени работы/учёбы и дороги запрещён. Норма проверок: не менее 1 раза в месяц (приказ № 403, п. 85)",
  "Uy-joy manzili — xaritadan bosib tanlang": "Адрес жилища — выберите на карте",
  "Radius (metr)": "Радиус (метры)",
  "Kichik radius yolg'on ogohlantirish beradi: uy ichida GPS aniqligi 50–100 metrgacha yomonlashadi": "Малый радиус даёт ложные тревоги: в помещении точность GPS падает до 50–100 метров",
  "Telefon": "Телефон",
  "Ruxsat etilgan vaqt": "Разрешённое время",
  "JK 48-1-moddasi: ish/o'qish vaqti va yo'l vaqtida uydan tashqarida bo'lish buzilish emas. Bu vaqt ko'rsatilmasa tizim qonuniy chiqishni buzilishdan ajrata olmaydi.": "Ст. 48-1 УК: нахождение вне дома во время работы/учёбы и дороги — не нарушение. Если это время не указано, система не отличит законный выход от нарушения.",
  "Ish boshlanishi": "Начало работы",
  "Ish tugashi": "Конец работы",
  "Yo'l vaqti (daq)": "Время в пути (мин)",
  "Ish kunlari": "Рабочие дни",
  "Du": "Пн",
  "Se": "Вт",
  "Ch": "Ср",
  "Pa": "Чт",
  "Ju": "Пт",
  "Sh": "Сб",
  "Ya": "Вс",
  "Chiqishga ruxsat:": "Выход разрешён:",
  "(yo'l vaqti hisobga olingan)": "(с учётом времени в пути)",
  "Saqlanmoqda…": "Сохранение…",
  "Tekshiruv qayd etildi": "Проверка зарегистрирована",
  "Saqlandi": "Сохранено",
  "Oylik norma:": "Месячная норма:",
  "Buzilish deb belgilandi.": "Отмечено как нарушение.",
  "Qoidabuzarlik aniqlangan kundan e'tiboran": "Со дня выявления нарушения",
  "1 oydan kechiktirmay": "не позднее 1 месяца",
  "intizomiy jazo (ogohlantirish) qo'llanadi — O'RQ-938, 62-modda.": "применяется дисциплинарное взыскание (предупреждение) — ЗРУ-938, ст. 62.",
  "Prokuror xabarnomasi yaratildi": "Создано уведомление прокурора",
  "Muddat:": "Срок:",
  "U \"Prokuror\" bo'limida navbatda turadi. Yuborgach belgilab qo'ying.": "Оно ждёт в разделе «Прокурор». После отправки отметьте его.",
  "Tekshiruv — {familiya} {ism}": "Проверка — {familiya} {ism}",
  "Tekshiruv turi": "Вид проверки",
  "Jismoniy tashrif": "Личное посещение",
  "Telefon orqali": "По телефону",
  "Joylashuvingiz aniqlanmoqda…": "Определяем ваше местоположение…",
  "Joylashuvingiz olindi (aniqlik ±{round} m) — tashrif dalili sifatida saqlanadi": "Местоположение получено (точность ±{round} м) — сохранится как подтверждение посещения",
  "Joylashuv olinmadi. Tekshiruv baribir saqlanadi, lekin tashrifning manzil dalili bo'lmaydi.": "Местоположение не получено. Проверка всё равно сохранится, но без подтверждения адреса посещения.",
  "Bu qurilmada joylashuv mavjud emas": "На этом устройстве геолокация недоступна",
  "Natija": "Результат",
  "Uyga kirilgani uchun": "Поскольку был вход в жилище,",
  "24 soat ichida prokurorni xabardor qilish shart": "прокурора необходимо уведомить в течение 24 часов",
  "(O'RQ-938, 24-modda). Saqlagach tizim muddatni o'zi sanaydi.": "(ЗРУ-938, ст. 24). После сохранения система сама отсчитывает срок.",
  "Kim bilan uchrashildi, nima aniqlandi…": "С кем встретились, что выяснили…",
  "Qayd etish": "Зарегистрировать",
  "Yuklashda xato": "Ошибка загрузки",
  "Harakat tarixi — {familiya} {ism}": "История перемещений — {familiya} {ism}",
  "{k} kun": "{k} дн.",
  "Uy koordinatasi belgilanmagan — masofa hisoblanmaydi. \"Sozlash\" tugmasi orqali xaritadan tanlang.": "Координаты дома не заданы — расстояние не рассчитывается. Выберите на карте через кнопку «Настроить».",
  "Uy-joy": "Жилище",
  "Uydan:": "От дома:",
  "Batareya:": "Батарея:",
  "Soxta GPS": "Поддельный GPS",
  "Aloqa tiklangach yuborilgan": "Отправлено после восстановления связи",
  "Ruxsat etilgan vaqtda tashqarida": "Вне дома в разрешённое время",
  "Ruxsatsiz tashqarida": "Вне дома без разрешения",
  "Vaqt — signal telefonda o'lchangan payt. Internet yo'q bo'lganda signal saqlanib, aloqa tiklangach yuboriladi.": "Время — момент измерения сигнала на телефоне. Без интернета сигнал сохраняется и отправляется после восстановления связи.",
  "Jami": "Всего",
  "ta signal": "сигналов",
  "Brauzer yangi oynani bloklab qo'ydi. Bu sayt uchun ": "Браузер заблокировал новое окно. Разрешите для этого сайта ",
  "qalqib chiquvchi oynalarga ruxsat bering.": "всплывающие окна.",
  "Dalolatnomani ochib bo'lmadi": "Не удалось открыть акт",
  "Surat yuklanmadi": "Фото не загружено",
  "Dalolatnoma imzolangach o'zgartirib bo'lmaydi. Imzolansinmi?": "После подписания акт нельзя изменить. Подписать?",
  "Imzolab bo'lmadi": "Не удалось подписать",
  "Suratlarni yuklab bo'lmadi": "Не удалось загрузить фото",
  "Mahkum imzo qo'ydi": "Осуждённый подписал",
  "Mahkum imzolashdan bosh tortdi": "Осуждённый отказался от подписи",
  "Mahkum yashash joyida bo'lmagan": "Осуждённый отсутствовал по месту жительства",
  "Dalolatnoma": "Акт",
  "Yuklanmoqda…": "Загрузка…",
  "Elektron imzolangan": "Подписан электронно",
  "Holis shaxslar:": "Понятые:",
  "SHA-256: {xesh}": "SHA-256: {xesh}",
  "DIQQAT:": "ВНИМАНИЕ:",
  "nazorat yig'indisi mos kelmadi — bazadagi yozuv o'zgartirilgan bo'lishi mumkin.": "контрольная сумма не совпала — запись в базе могла быть изменена.",
  "Hujjat hali imzolanmagan. Imzolangach u": "Документ ещё не подписан. После подписания он",
  "o'zgarmaydi": "не изменяется",
  "xatosi bo'lsa yangi tekshiruv qayd etiladi.": "при ошибке регистрируется новая проверка.",
  "Mahkumning imzosi": "Подпись осуждённого",
  "Tekshiruv natijasiga ko'ra mahkum hujjatni imzolay olmaydi.": "По результату проверки осуждённый не может подписать документ.",
  "Holis shaxslar": "Понятые",
  " — kamida {xolis_eng_kam} ta shart": " — обязательно не менее {xolis_eng_kam}",
  " (ixtiyoriy)": " (необязательно)",
  "F.I.Sh.": "Ф.И.О.",
  "Manzili": "Адрес",
  "Holis shaxs": "Понятой",
  "Qo'shimcha izoh (ixtiyoriy)": "Дополнительный комментарий (необязательно)",
  "Masalan: xonadonda hech kim bo'lmadi": "Например: в квартире никого не было",
  "Fotosuratlar ({soni} ta)": "Фотографии ({soni})",
  "surat": "фото",
  "Surat qo'shilmagan": "Фото не добавлено",
  "+ Surat qo'shish": "+ Добавить фото",
  "Imzolanmoqda…": "Подписание…",
  "Elektron imzolash": "Подписать электронно",
  "Tayyorlanmoqda…": "Подготовка…",
  "Chop etish": "Печать",
  "Rasmni ochib bo'lmadi": "Не удалось открыть изображение",
  "Tekshiruv fotosi": "Фото проверки",
  "Bu shaxsga doir maxsus ma'lumot (O'RQ-938, 47-modda). Ochilgani jurnalga yozildi.": "Это персональные данные особой категории (ЗРУ-938, ст. 47). Просмотр записан в журнал.",
  "Qo'ng'iroqni boshlab bo'lmadi": "Не удалось начать звонок",
  "Ulanmoqda…": "Подключение…",
  "Chaqirilmoqda…": "Вызов…",
  "Mahkum qo'ng'iroqni rad etdi": "Осуждённый отклонил звонок",
  "Javob berilmadi": "Нет ответа",
  "Suhbat tugadi": "Разговор завершён",
  "Qo'ng'iroq — {familiya} {ism}": "Звонок — {familiya} {ism}",
  "Mahkum telefonida jiringlayapti. 45 soniyada javob bermasa — \"javob berilmadi\" deb qayd etiladi.": "Звонит на телефоне осуждённого. Если он не ответит за 45 секунд — будет записано «нет ответа».",
  "🎤 Mikrofon yoniq": "🎤 Микрофон включён",
  "🔇 Mikrofon o'chiq": "🔇 Микрофон выключен",
  "Tugatish": "Завершить",
  "Suhbat \"telefon\" turidagi tekshiruv sifatida avtomatik qayd etiladi. Bu 84/85-banddagi jismoniy tashrif normasiga kirmaydi.": "Разговор автоматически регистрируется как проверка по телефону. Он не входит в норму личных посещений по пп. 84/85.",
  "Ma'lumotni olishda xato": "Ошибка получения данных",
  "Xato": "Ошибка",
  "So'rov yuborildi. Mahkum 15 daqiqa ichida javob berishi kerak.": "Запрос отправлен. Осуждённый должен ответить в течение 15 минут.",
  "Panel": "Панель",
  "Nazoratdagilar": "Под контролем",
  "Tekshiruvlar": "Проверки",
  "Prokuror": "Прокурор",
  "Ozodlikni cheklash jazosi · O'RQ-938 34-modda, 403-son buyruq 84–85-band": "Наказание в виде ограничения свободы · ЗРУ-938 ст. 34, приказ № 403 пп. 84–85",
  "Ma'lumot har 20 soniyada yangilanadi": "Данные обновляются каждые 20 секунд",
  "Ilova o'rnatilgan": "Приложение установлено",
  "Ochiq ogohlantirish": "Открытые тревоги",
  "Ogohlantirishlar": "Тревоги",
  "Ochiq ogohlantirish yo'q — hammasi joyida.": "Открытых тревог нет — всё в порядке.",
  "Ko'rdim": "Просмотрено",
  "Tashrif normasi bo'yicha qarzdorlik": "Задолженность по норме посещений",
  "Faqat": "Засчитывается только",
  "jismoniy tashrif": "личное посещение",
  "hisoblanadi. Onlayn va telefon tekshiruvi qo'shimcha nazorat — u 84/85-banddagi normani to'ldirmaydi. Oy oxiriga {qolgan_kun} kun qoldi.": "— онлайн- и телефонные проверки являются дополнительным контролем и норму пп. 84/85 не восполняют. До конца месяца {qolgan_kun} дн.",
  "Barcha normalar bajarilgan.": "Все нормы выполнены.",
  " · oxirgi tashrif {qanchaOtdi}": " · последнее посещение {qanchaOtdi}",
  "{qoldi} ta qoldi": "осталось {qoldi}",
  " · shoshilinch": " · срочно",
  "Ozodlikni cheklash jazosidagi mahkum topilmadi. Mahkumlar reyestrida jazo turini \"Ozodlikni cheklash\" deb belgilang.": "Осуждённых к ограничению свободы не найдено. В реестре осуждённых укажите вид наказания «Ограничение свободы».",
  "Rejim belgilanmagan": "Режим не задан",
  " · norma {oylik_tashrif}/{kerak}": " · норма {oylik_tashrif}/{kerak}",
  "Oxirgi signal: {qanchaOtdi}": "Последний сигнал: {qanchaOtdi}",
  " · batareya {batareya}%": " · батарея {batareya}%",
  "{ochiq_hodisa} ta ochiq ogohlantirish": "открытых тревог: {ochiq_hodisa}",
  "Sozlash": "Настроить",
  "Xarita": "Карта",
  "Tekshiruv": "Проверка",
  "Hozir tekshir": "Проверить сейчас",
  "Qo'ng'iroq": "Звонок",
  "Avval rejim va uy manzilini sozlang": "Сначала настройте режим и адрес дома",
  "Ilova kodi": "Код приложения",
  "Nazorat sozlanmagan:": "Контроль не настроен:",
  "jazo rejimi": "режим наказания",
  " va ": " и ",
  "uy koordinatasi": "координаты дома",
  "ko'rsatilmagan.": "не указаны.",
  "Tekshiruvlar tarixi": "История проверок",
  "Har bir tekshiruv bo'yicha dalolatnoma chop etish mumkin (403-son buyruq, 84–85-bandlar).": "По каждой проверке можно распечатать акт (приказ № 403, пп. 84–85).",
  "Hali tekshiruv o'tkazilmagan.": "Проверок пока не было.",
  "Tashrif": "Посещение",
  "Onlayn": "Онлайн",
  "Buzilish": "Нарушение",
  "Natija belgilanmagan": "Результат не указан",
  "Xodim uydan {xodim_masofa_m} m": "Сотрудник в {xodim_masofa_m} м от дома",
  "Mahkum uydan {mahkum_masofa_m} m": "Осуждённый в {mahkum_masofa_m} м от дома",
  " · SOXTA GPS": " · ПОДДЕЛЬНЫЙ GPS",
  "Foto": "Фото",
  "✓ Dalolatnoma № {dalolatnoma_raqami}": "✓ Акт № {dalolatnoma_raqami}",
  "Dalolatnoma tuzish": "Составить акт",
  "24 soatlik xabarnomalar": "24-часовые уведомления",
  "O'RQ-938 24-moddasi: mahkum uyiga kirilgan": "Ст. 24 ЗРУ-938: о",
  "har bir hol": "каждом случае",
  "haqida 24 soat ichida prokurorni": "входа в жилище осуждённого в течение 24 часов прокурора необходимо уведомить",
  "yozma yoki elektron shaklda": "в письменной или электронной форме",
  "xabardor qilish shart (403-son buyruq, 127-band).": "(приказ № 403, п. 127).",
  "Kutilayotgan xabarnoma yo'q.": "Ожидающих уведомлений нет.",
  "Tashrif: {vaqtMatni}": "Посещение: {vaqtMatni}",
  "{floor} soat {round} daqiqa qoldi": "осталось {floor} ч {round} мин",
  "Muddat o'tib ketdi": "Срок истёк",
  "Elektron yuborildi": "Отправлено электронно",
  "Yozma": "Письменно",
  "Ilovani biriktirish kodi": "Код привязки приложения",
  "{familiya} {ism} uchun": "для {familiya} {ism}",
  "Mahkum Play Market'dan": "Осуждённый устанавливает из Play Market приложение",
  "prob24": "prob24",
  "ilovasini o'rnatadi": "",
  "Shu kodni kiritadi — parol yoki ro'yxatdan o'tish kerak emas": "Вводит этот код — пароль и регистрация не нужны",
  "Joylashuvga": "Даёт доступ к геолокации:",
  "\"Doim ruxsat\"": "«Разрешить всегда»",
  "beradi": "",
  "Batareya cheklovini o'chiradi (ilova o'zi so'raydi)": "Отключает ограничение батареи (приложение само попросит)",
};

export default lugat;
